module.exports = __webpack_public_path__ + "img/nag1.d4a4e1a3.png";